import axios from 'axios'
import { size } from 'lodash'
import swal from 'sweetalert'
import feathers from 'src/services/feathers'
import moment from 'moment'

export const loadOptionsOriginAirport = async (inputValue, iataValidation) => {
  const baseUrl = `${process.env.REACT_APP_URL_FEATHERS}`
  const endpoint = `/airports?$limit=50&$or[0][airport_id][$search]=${inputValue}&$or[1][name][$search]=${inputValue}&$or[2][iata][$search]=${inputValue}&$or[3][country][$search]=${inputValue}&iata[$ne]=${iataValidation}`
  const response = await axios.get(`${baseUrl}${endpoint}`)
  return response.data
}

export const getOptionsPort = async (setPortsOfEntry) => {
  await axios
    .get(`${process.env.REACT_APP_URL_FEATHERS}/ports/portOfEntry`)
    .then(async function (response) {
      setPortsOfEntry(response.data.items)
    })
}

export const getDataCustomerIor = async (data, setIorCustomer, navigate) => {
  if (data) {
    await axios
      .get(`${process.env.REACT_APP_URL_FEATHERS}/customers?_id=${data._id}`)
      .then(async function (response) {
        setIorCustomer(response.data[0].ior)
      })
  } else {
    swal({
      title: 'Select Customer',
      icon: 'error',
    }).then((res) => {
      if (res) {
        navigate('/customers')
      } else {
        navigate('/customers')
      }
    })
  }
}

export function generateUUID() {
  var d = new Date().getTime()
  var uuid = 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = (d + Math.random() * 16) % 16 | 0
    d = Math.floor(d / 16)
    return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16)
  })
  return uuid
}

export function validateMasterNumber(number) {
  const re = /^[0-9]*(\.?)[0-9]+$/g
  return re.test(number)
}

export function viewInvoice(base64URL) {
  var win = window.open()
  win.document.write(
    '<iframe src="' +
      base64URL +
      '" frameborder="0" style="border:0; top:0px; left:0px; bottom:0px; right:0px; width:100%; height:100%;" allowfullscreen></iframe>',
  )
}

export function viewFile(name) {
  window.open(`https://devstorext.blob.core.windows.net/shipments/${name}`)
}

export const selectShipments = (pathName, id, setSelect, typeShipment, validAll) => {
  window.location.href = `/#/operations/${pathName[5]}/edit-shipment-${typeShipment}/${id}/${validAll}`
  setSelect('Shipments')
}

export const selectFiles = (pathName, id, setSelect, typeShipment, validAll) => {
  window.location.href = `/#/operations/${pathName[5]}/edit-shipment-${typeShipment}/${id}/${validAll}`
  setSelect('Files')
}

export const selectChat = (pathName, id, setSelect, typeShipment, validAll) => {
  window.location.href = `/#/operations/${pathName[5]}/edit-shipment-${typeShipment}/${id}/${validAll}/chat`
  setSelect('Chat')
}

export const getTypeShipment = (pathName, setTypeShipment) => {
  if (['edit-shipment-air'].includes(pathName[6]) || ['air'].includes(pathName[7])) {
    setTypeShipment('air')
  } else if (['edit-shipment-ocean'].includes(pathName[6]) || ['ocean'].includes(pathName[7])) {
    setTypeShipment('ocean')
  } else {
    setTypeShipment('truck')
  }
}

export const handleInvoiceFileChange = (e, invoiceAppend, getValues) => {
  let selectedFile = e.target.files[0]
  if (selectedFile) {
    let reader = new FileReader()
    reader.readAsDataURL(selectedFile)
    reader.onloadend = async (e) => {
      invoiceAppend({
        name: new Date().getTime() + selectedFile.name,
        id: generateUUID(),
        type: selectedFile.type,
        result: e.target.result,
        fileType: getValues('typeFile'),
      })
    }
  } else {
    swal({
      title: 'Select a file',
      icon: 'error',
      button: 'Accept',
    })
  }
}

export const updateStatusReview = async (id, user, setSendReview) => {
  const query = {
    transactionId: { $in: id },
  }
  const docs = await feathers.service('documents').find({ query })
  if (docs.length) {
    feathers
      .service('transactions')
      .patch(id, {
        status: 'REVIEW',
        readyToSend: true,
      })
      .then(function () {
        feathers
          .service('chat-message')
          .create({
            text: 'Request review send sucessfull',
            createdBy: user.sub,
            read: false,
            transactionId: id,
          })
          .then(async function (response) {
            feathers
              .service('notifications')
              .create({
                text: response.text,
                createdBy: response.createdBy,
                targetType: 'role',
                targetId: 'admin',
                read: false,
                link: window.location.href,
              })
              .then(async function (response) {
                setSendReview(true)
              })
              .catch(function (error) {
                console.log('🚀 ~ file: EditShipmentAir.js:629 ~ error', error)
              })
            swal({
              title: 'Message sent',
              icon: 'success',
            })
          })
          .catch(function (error) {
            console.log('🚀 ~ file: EditShipmentAir.js:637 ~ error', error)
            swal({
              title: error,
              icon: 'error',
            })
          })
      })
      .catch(function (error) {
        swal({
          title: error,
          icon: 'error',
        })
      })
  } else {
    swal({
      title: 'You must provide at least 1 house!',
      icon: 'error',
    })
  }
}

export const updateEditHousesTotal = async (errors, numbersErrors, id, shipmentFields) => {
  await feathers
    .service('transactions')
    .patch(id, {
      'docOrigin.houseCount': Number(size(shipmentFields)) - Number(size(errors)),
    })
    .then(function (response) {
      // console.log('🚀 ~ file: ECommerceShipmentsAir.js:459 ~ response', response)
      if (size(errors) > 0) {
        swal({
          title: 'Error Uploaded',
          text: numbersErrors.toString(),
          icon: 'error',
        })
      }
    })
    .catch(function (error) {
      console.log('🚀 ~ file: EditShipmentOcean.js:695 ~ updateHousesTotal ~ error', error)
    })
}

export const deleteShipment = async (params, shipmentRemove, setDocumentsRemove) => {
  swal({
    title: '¿Are You Sure?',
    icon: 'warning',
    buttons: ['Cancel', 'Accept'],
  }).then(async (res) => {
    if (res) {
      shipmentRemove(params.rowIndex)
      if (params.data._id) {
        setDocumentsRemove((documentsRemove) => [...documentsRemove, params.data._id])
      }
    }
  })
}

export function currencyFormatterDate(params) {
  return moment(params.value).format('L')
}
